import { generateResourceReducer } from '../generators/resource.reducer';
import * as types from './project-member.types';
import * as constants from './project-member.constants';

export const projectTeamReducer = generateResourceReducer<types.IProjectTeam>({
  STORE: constants.STORE_PROJECT_TEAM,
  CLEAR: constants.CLEAR_PROJECT_MEMBER,
});
